exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TranslationNotice__bar--2DtTg {\n  width: 100%;\n  color: #f9f9f9;\n  background-color: #0c0d0e;\n  line-height: 1.25;\n  letter-spacing: 0.3px;\n  font-weight: 400;\n  font-size: 12px;\n}\n\n.TranslationNotice__container--3mfP0 {\n  margin: 0 auto;\n  padding: 6px 10px;\n  max-width: 1024px;\n}\n\n.TranslationNotice__translatedByCopy--1lxyQ {\n  opacity: 0.65;\n}\n\n.TranslationNotice__englishBtn--4uvdy {\n  font-weight: 500;\n  opacity: 0.8;\n  text-align: right;\n}\n.TranslationNotice__englishBtn--4uvdy a {\n  color: #f9f9f9;\n}", ""]);

// exports
exports.locals = {
	"bar": "TranslationNotice__bar--2DtTg",
	"container": "TranslationNotice__container--3mfP0",
	"translatedByCopy": "TranslationNotice__translatedByCopy--1lxyQ",
	"englishBtn": "TranslationNotice__englishBtn--4uvdy"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };